// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6093c0f7","239":"8ab4a25e","453":"e5d885ca","455":"605a2f81"}[chunkId] + ".chunk.js";
};